import React from 'react';
import PropTypes from 'prop-types';

import './scss/stepInception.scss';

const StepInception = ({ children, images }) => {
  return (
    <div className="step--inception">
      <p className="header">{ children }</p>

      <div className="img">
        { images.map(img => <img alt="" src={ img } />) }
      </div>
    </div>
  );
};

StepInception.defaultProps = {
  images: []
};

StepInception.propTypes = {
  children: PropTypes.node.isRequired,
  images: PropTypes.array,
};

export default StepInception;



// WEBPACK FOOTER //
// ./src/components/Setup/components/StepInception.js